import { PropsWithChildren, ReactElement } from 'react';

import { FilterContext } from './filter-context';

export interface FilterProps {
    searchParams: URLSearchParams;
    updateSearch: (searchParams: URLSearchParams) => void;
}

export const Filter = (props: PropsWithChildren<FilterProps>): ReactElement => {
    const updateFilter = (changes: URLSearchParams): void => {
        props.updateSearch(changes);
    };

    return (
        <FilterContext.Provider
            value={{
                filter: props.searchParams,
                updateFilter,
            }}
        >
            {props.children}
        </FilterContext.Provider>
    );
};
